export {default as config} from "../config/config";



//////////////////
// WEBPACK FOOTER
// ./src/services/external.js
// module id = 720
// module chunks = 0